import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useConfigLayout } from "../../../hooks/useConfigLayout";
import UtilityPageLayout from "../component/layout/UtilityPageLayout";
import { FeatureFlagName } from "../../../tenant/features/featureFlags";
import Button from "../../../common/components/xepp/button/Button";
import { ReferralSystemList } from "./ReferralSystemList";
import AddStaffModal, { StaffFormData } from "./components/AddStaffModal";
import { getErrorMessage } from "../../../utils/error-handler";
import { formatBulkErrorMessage } from "../../../utils/format-bulk-message";
import styles from './ReferralSystem.module.scss'
import { useAddBulkStaffReferralMutation, useAddSingleStaffReferralMutation } from "../../../service/referral-service";
import { hasPermission } from "../../../guards/common/authentification-functions";
import { UtilityPermissions } from "../../../model/permissions/permissions";



export const SystemReferralPage = () => {
    const { updateLayout } = useConfigLayout();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [addSingleStaffReferral, { isLoading }] = useAddSingleStaffReferralMutation();
    const [addBulkStaff, { isLoading: isLoadingBulk }] = useAddBulkStaffReferralMutation();
    useEffect(() => {
        updateLayout({ showBreadCrumb: false });
    }, []);

    const handleAddStaff = async (data: StaffFormData) => {
        if (data.uploadType === 'Single') {
            try {
                await addSingleStaffReferral({
                    fullName: data.name,
                    email: data.email,
                    staffId: data.staffId,
                    phoneNumber: data.phoneNumber,
                }).unwrap();
                toast.success("Staff successfully added.");

                setIsModalOpen(false);
            } catch (err: any) {
                toast.error(getErrorMessage(err?.data) ?? "Failed to add staff.");
            }
        } else {
            addBulkStaff(data.file!)
                .unwrap()
                .then((data) => {
                    if (data.failedRows.length > 0) {
                        if (data.successCount > 0) {
                            toast.warn(formatBulkErrorMessage(data.failedRows.length, data.failedRows, data.successCount));
                            setIsModalOpen(false);
                        } else {
                            toast.error(formatBulkErrorMessage(data.failedRows.length, data.failedRows, data.successCount))
                        }

                    }
                    else {
                        toast.success("Staffs successfully uploaded.");
                        setIsModalOpen(false);
                    }

                })
                .catch((err: any) => {
                    toast.error(getErrorMessage(err?.data) ?? "Failed to upload staff.");
                });
        }
    };

    return (
        <>
            <UtilityPageLayout
                title="Referral System"
                feature={FeatureFlagName.ADMIN_REFERRAL_SYSTEM}
                customButton={
                    hasPermission(UtilityPermissions.AddStaffReferral)
                        ? <Button text="Add Staff" onClick={() => setIsModalOpen(true)} className={styles.btn} />
                        : false
                }
            >
                <ReferralSystemList />
            </UtilityPageLayout>

            {isModalOpen && (
                <AddStaffModal
                    onClose={() => setIsModalOpen(false)}
                    onSubmit={handleAddStaff}
                    isLoading={isLoading || isLoadingBulk}
                />
            )}
        </>
    );
};
